import React, { createContext, useCallback } from 'react'
import Grid from '@mui/material/Grid'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import { usePopupState, bindToggle } from 'material-ui-popup-state/hooks'

import CascadingMenu from './CascadingMenu'
import { Paragraph } from 'components/shared'
import { TaskData } from '../TaskAside.style'
import { Box, Icon } from '@centra/centra-ui'
import CascadingMenuItemList from './CascadingMenuItemList'

interface ICascadingContext {
  parentPopupState: any
  rootPopupState: any
}

export const CascadingContext = createContext<ICascadingContext>({
  parentPopupState: null,
  rootPopupState: null,
})

export interface INestedMenuItem {
  id: number
  name: string
  clients?: INestedMenuItem[]
}

export interface IClientOption {
  id: number
  name: string
  clients?: IClientOption[]
}

interface ClientsNestedDropdownProps {
  value: IClientOption | null
  menuItems: INestedMenuItem[]
  onChange: (id: number) => void
}

const ClientsNestedDropdown = (props: ClientsNestedDropdownProps) => {
  const { value, menuItems, onChange } = props
  const popupState = usePopupState({
    popupId: 'clientsDropdown',
    variant: 'popover',
  })
  const handleClickAway = useCallback(() => {
    popupState.close()
  }, [popupState])

  return (
    <TaskData>
      <label>Клиент</label>

      <ClickAwayListener onClickAway={handleClickAway}>
        <div>
          <button {...bindToggle(popupState)}>
            <Grid container alignItems={'center'}>
              <Grid item>
                {value ? (
                  <Paragraph size={'sm'} weight={'bold'}>
                    {value.name}
                    {!!value.clients?.length && ` / ${value.clients[0].name}`}
                  </Paragraph>
                ) : (
                  <Paragraph size={'sm'} weight={'bold'}>
                    Нет
                  </Paragraph>
                )}
              </Grid>
              <Grid item>
                <Box marginLeft={2}>
                  <Icon name={'triangle'} size={11} />
                </Box>
              </Grid>
            </Grid>
          </button>
          <CascadingMenu
            style={{ zIndex: 10000 }}
            popupState={popupState}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          >
            <CascadingMenuItemList menuItems={menuItems} onChange={onChange} handleClickAway={handleClickAway} />
          </CascadingMenu>
        </div>
      </ClickAwayListener>
    </TaskData>
  )
}

export default ClientsNestedDropdown
